if (!customElements.get("m-brand-list")) {
  class MBrandList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      
      const wrapper = this.querySelector("[data-wrapper]");
      if (wrapper && !wrapper.classList.contains("swiper-wrapper")) {
        wrapper.classList.add("swiper-wrapper");
      }
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");

      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 4.4, // 4 full slides + partial 5th slide to indicate swiping
          slidesPerGroup: 1,  
          spaceBetween:14,    // Tighter gap for mobile to match Figma
          loop: false,        
          autoplay: autoplay ? { delay: parseInt(autoplaySpeed) * 1000 } : false,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 5,
              spaceBetween: 20, 
            },
            1024: {
              slidesPerView: 7, 
              spaceBetween: 30,
            },
          },
        });
      }
    }
  }

  customElements.define("m-brand-list", MBrandList);
}